import Transformer from '../transformer'

/**
 * @author Andres Aguilar <andresyoshimar@gmail.com>
 */

export default class FilesTransformer extends Transformer {
  static fetch (element) {
    return {
      file: element.file,
      name: element.file_type.file_type_name,
      description: element.file_type.file_type_description,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/extranet/FilesTransformer.js